import { IDENTITYKEY } from '@/store/User';

// 获取支付类型
export const getPlanTag = (skuType: IDENTITYKEY, dateType: 'month' | 'year' | 'once') => {
  if (dateType === 'once') {
    return 'Credit';
  }

  if (skuType === 'basicVip') {
    if (dateType === 'month') return 'S1';
    if (dateType === 'year') return 'S2';
  }

  if (skuType === 'advancedVip') {
    if (dateType === 'month') return 'P1';
    if (dateType === 'year') return 'P2';
  }

  return 'Other';
};
